import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import useData from "hooks/useData";

export function useViewData(name, queryString, refreshToken) {
  const [ view, setView ] = useState();
  const [ isLoading, setIsLoading ] = useState(true);
  const { getData } = useData();

  let path = `rest/${ name }`;

  useEffect(
    () => {
      const load = async () => {
        setIsLoading(true);
        let result;
        try {
          result = await getData(path, queryString);
        } catch (exception) {
          console.error(exception);
        }
        setView(result.data);
        setIsLoading(false);
      }
      load();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ name, queryString, refreshToken ]);

  return { view, isLoading }
}

useViewData.propTypes = {
  name: PropTypes.string.isRequired,
  page: PropTypes.number,
  filters: PropTypes.string,
  search: PropTypes.string,
  query: PropTypes.object,
}

export default useViewData;
